import { withTrailingSlash } from '../../../utils/trailingSlash';
import {
    CTALocation,
    KontentStringValue,
} from '../../../../types/KontentProps';

export function BuildLinkHref(
    cta: CTALocation | undefined,
    anchorPoint: KontentStringValue | undefined = undefined,
    addTrailingSlash?: Boolean | undefined
) {
    if (!cta?.value || !cta?.value.length) {
        return '';
    }
    const addAnchor = (url: string) => {
        const anchor = anchorPoint?.value ? `#${anchorPoint.value}` : '';
        return withTrailingSlash(url) + anchor;
    };

    if (cta?.value[0]?.elements?.third_party_url?.value) {
        return addAnchor(cta?.value[0]?.elements?.third_party_url?.value);
    }
    if (cta?.value[0]?.elements?.file?.value[0]?.url) {
        return addAnchor(cta?.value[0]?.elements?.file?.value[0]?.url);
    }
    if (cta?.value[0]?.elements?.document?.value[0]?.url) {
        return addAnchor(cta?.value[0]?.elements?.document?.value[0]?.url);
    }

    if (
        !cta?.value[0]?.elements?.slug?.url &&
        cta?.value[0]?.elements?.slug?.value
    ) {
        return addAnchor(`/${cta?.value[0]?.elements?.slug?.value}`);
    }

    return addAnchor(`${cta?.value[0]?.elements?.slug?.url}`);
}
